var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManagementTeamIconsGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 204.102,
    height: 141.987,
    viewBox: "0 0 204.102 141.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8970",
    "data-name": "Group 8970",
    transform: "translate(-1020.867 -103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8949",
    "data-name": "Group 8949",
    transform: "translate(21 -61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8948",
    "data-name": "Group 8948"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1238",
    "data-name": "Rectangle 1238",
    width: 94.93,
    height: 83.702,
    rx: 10.144,
    transform: "translate(1115.952 164) rotate(22)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7343",
    "data-name": "Path 7343",
    d: "M59.109,70.785h-8L49.862,67.2c-.552-.138-.966-.414-1.518-.552l-3.588,1.932-5.8-5.658,1.794-3.45a16.191,16.191,0,0,1-.69-1.518L36.2,56.709v-8l3.588-1.242c.138-.552.414-.966.552-1.518l-1.932-3.588,5.658-5.8,3.45,1.794a16.189,16.189,0,0,1,1.518-.69L50.276,33.8h8l1.242,3.588c.552.138.966.414,1.518.552l3.588-1.932,5.658,5.658-1.794,3.45a16.185,16.185,0,0,1,.69,1.518l3.864,1.242v8l-3.588,1.242c-.138.552-.414.966-.552,1.518l1.932,3.588-5.52,5.934-3.45-1.794c-.552.276-.966.414-1.518.69ZM52.9,68.163h4.278l1.1-3.312.69-.276a16.835,16.835,0,0,0,2.346-.966l.69-.414,2.9,1.518,2.9-2.9-1.656-3.036.276-.552a16.835,16.835,0,0,0,.966-2.346l.138-.69,3.174-1.1V49.809l-3.312-1.1-.276-.69a16.836,16.836,0,0,0-.966-2.346l-.414-.552,1.518-2.9-2.9-2.76-3.174,1.518-.69-.276a16.835,16.835,0,0,0-2.346-.966l-.552-.138-1.1-3.174H52.209l-1.1,3.312-.69.276c-.828.276-1.656.69-2.346.966l-.414.414-2.9-1.656-2.9,2.9,1.656,3.036-.276.552a11.938,11.938,0,0,0-.966,2.346l-.138.69-3.174,1.1v4.278l3.312,1.1.276.69c.276.828.69,1.656.966,2.346l.414.69-1.656,2.9,2.9,2.9,3.036-1.656.552.276a11.939,11.939,0,0,0,2.346.966l.69.138Zm1.932-9.66a6.331,6.331,0,0,1-6.348-6.348,6.348,6.348,0,0,1,12.7,0A6.42,6.42,0,0,1,54.831,58.5Zm0-9.936a3.588,3.588,0,1,0,3.588,3.588A3.751,3.751,0,0,0,54.831,48.566Z",
    transform: "translate(1123.125 147.408) rotate(30)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8947",
    "data-name": "Group 8947"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1237",
    "data-name": "Rectangle 1237",
    width: 109.628,
    height: 109.628,
    rx: 10.144,
    transform: "translate(999.867 196.359)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8971",
    "data-name": "Group 8971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8946",
    "data-name": "Group 8946",
    transform: "translate(1037.221 158.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7347",
    "data-name": "Path 7347",
    d: "M22.259,27.5a7.674,7.674,0,1,0-7.674,7.674A7.686,7.686,0,0,0,22.259,27.5Zm-7.674,5.969A5.969,5.969,0,1,1,20.554,27.5,5.975,5.975,0,0,1,14.585,33.465Zm11.085,16.2V42.844A7.686,7.686,0,0,0,18,35.17H11.174A7.686,7.686,0,0,0,3.5,42.844v6.822a.844.844,0,0,0,.853.853H24.817A.844.844,0,0,0,25.67,49.666Zm-1.705-.853H5.205V42.844a5.975,5.975,0,0,1,5.969-5.969H18a5.975,5.975,0,0,1,5.969,5.969ZM62.336,35.17A7.674,7.674,0,1,0,54.662,27.5,7.686,7.686,0,0,0,62.336,35.17Zm0-13.643A5.969,5.969,0,1,1,56.367,27.5,5.975,5.975,0,0,1,62.336,21.527ZM51.251,42.844v6.822a.844.844,0,0,0,.853.853H72.568a.844.844,0,0,0,.853-.853V42.844a7.686,7.686,0,0,0-7.674-7.674H58.925A7.686,7.686,0,0,0,51.251,42.844Zm14.5-5.969a5.975,5.975,0,0,1,5.969,5.969v5.969H52.956V42.844a5.975,5.975,0,0,1,5.969-5.969Zm-19.612-16.2a7.674,7.674,0,1,0-7.674,7.674A7.686,7.686,0,0,0,46.135,20.674ZM38.46,26.643a5.969,5.969,0,1,1,5.969-5.969A5.975,5.975,0,0,1,38.46,26.643Zm-11.085,9.38v6.822a.844.844,0,0,0,.853.853H48.693a.844.844,0,0,0,.853-.853V36.023a7.686,7.686,0,0,0-7.674-7.674H35.05A7.686,7.686,0,0,0,27.375,36.023Zm14.5-5.969a5.975,5.975,0,0,1,5.969,5.969v5.969H29.081V36.023a5.975,5.975,0,0,1,5.969-5.969Z",
    transform: "translate(0 0)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8969",
    "data-name": "Group 8969",
    transform: "translate(886.779 148.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7377",
    "data-name": "Path 7377",
    d: "M192.988,109h-2.659l-.629,9.118,1.958,1.852,1.958-1.852Zm-.56.6h-1.54l-.571,8.277,1.341,1.267L193,117.876Z",
    transform: "translate(-2.821 -69.708)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.8,
    fillRule: "evenodd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementTeamIconsGroup);
export default __webpack_public_path__ + "static/media/management-team-icons-group.e5da5c31e3a0e95b70a0f6ee1de592b9.svg";
export { ForwardRef as ReactComponent };